import {ADD_FILE, CLEAR_FILES, DELETE_FILE, SET_FILE, UPDATE_FILE} from "../actions/FileActions";
import QueryStorage from "../../../../common/helpers/QueryStorage";

const FILES_QUERY_KEY = 'files';

function hydrate() {
    try {
        const raw = QueryStorage.get(FILES_QUERY_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

function persist(data) {
    try {
        const safe = data.filter(f => f.status && !f.uploading);
        if (safe.length === 0) QueryStorage.remove(FILES_QUERY_KEY);
        else QueryStorage.set(FILES_QUERY_KEY, JSON.stringify(safe));
    } catch {
    }
}

const initialState = {
    data: hydrate(),
};

export default function FileReducer(state = initialState, action) {
    const isCurrentFile = file => {
        return file.uid === action.payload.uid;
    }

    let next = state;

    switch (action.type) {
        case ADD_FILE:
            next = {data: state.data.concat([action.payload])};
            break;

        case UPDATE_FILE:
            next = {
                data: state.data.map(file => isCurrentFile(file) ? action.payload : file),
            };
            break;

        case DELETE_FILE:
            next = {
                data: state.data.reduce((data, file) => isCurrentFile(file) ? data : data.concat([file]), []),
            };
            break;

        case CLEAR_FILES:
            next = {data: []};
            break;

        default:
            return state;
    }

    persist(next.data);
    return next;
}
